import Invoices from '../../../../store/billing/invoices/index';

angular
    .module('festzelt-os.billing.invoices')
    .factory('Invoices', [
        '$injector',
        'Invoice',
        ($injector, Invoice) => new Invoices(Invoice, {
            injector: $injector
        })
    ]);



// WEBPACK FOOTER //
// ./src/app/pages/billing/invoices/store/invoices.js